import { render, staticRenderFns } from "./WorkspaceSetting.vue?vue&type=template&id=08528f62&scoped=true"
import script from "./WorkspaceSetting.vue?vue&type=script&lang=js"
export * from "./WorkspaceSetting.vue?vue&type=script&lang=js"
import style1 from "./WorkspaceSetting.vue?vue&type=style&index=1&id=08528f62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08528f62",
  null
  
)

export default component.exports